import { makeStyles } from '@material-ui/core'
import { Box, useBreakpointSm } from '@plvs/respawn/features/layout'
import React, { SyntheticEvent } from 'react'
import { NxButton } from '@playvs-inc/nexus-components'
import { Path } from '@plvs/const'

import { useLocation, useNavigate } from 'react-router'
import { useUserIdentityFn } from '@plvs/client-data/hooks'
import { AppDrawerToggles } from './drawer/AppDrawerToggles'

const useStyles = makeStyles({
  signedIn: {
    display: 'flex',
    height: '92px',
  },
})

interface Props {
  showLogout?: boolean
}

const AppSignupButton: React.FC<Props> = ({ showLogout }) => {
  const navigate = useNavigate()
  const { userId, isParent } = useUserIdentityFn()

  const isMobile = useBreakpointSm()
  const location = useLocation()
  const classes = useStyles()

  // If user clicks logout during onboarding, prompt the user. - ID-907
  const handleOnLogout = (evt: SyntheticEvent): void => {
    if (location.pathname.startsWith(Path.SpawnPoint)) {
      // eslint-disable-next-line no-alert
      const result = window.confirm(
        'Do you wish to logout? Changes you made may not be saved.'
      )

      evt.stopPropagation()
      evt.preventDefault()

      if (result) {
        navigate(Path.Logout)
      }
    }
    if (!location.pathname.startsWith(Path.SpawnPoint)) {
      navigate(Path.Logout)
    }
  }

  const onSignUpClick = (): void => {
    navigate(Path.Registration)
  }

  const rightAppBarContent = !isParent && <AppDrawerToggles isInAppBar />

  return userId ? (
    <Box className={isMobile && !showLogout ? classes.signedIn : ''}>
      {isMobile && !showLogout ? (
        rightAppBarContent
      ) : (
        <NxButton
          data-testid="AppSignUpButton__LogoutButton"
          label="Logout"
          onClick={handleOnLogout}
          onClickCapture={handleOnLogout}
          variant="secondary"
        />
      )}
    </Box>
  ) : (
    <NxButton
      data-testid="AppSignUpButton__SignUpButton"
      label="Sign Up"
      onClick={onSignUpClick}
      variant="secondary"
    />
  )
}

export default AppSignupButton
